/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_LanguagesListResponse } from '../models/models_LanguagesListResponse';
import type { models_OrgLocalizationResponse } from '../models/models_OrgLocalizationResponse';
import type { models_OrgLocalizationUpdateRequest } from '../models/models_OrgLocalizationUpdateRequest';
import type { models_RegionsListResponse } from '../models/models_RegionsListResponse';
import type { models_TimezonesListResponse } from '../models/models_TimezonesListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LocalizationService {
    /**
     * List available languages
     * Returns all languages supported by the platform
     * @returns models_LanguagesListResponse OK
     * @throws ApiError
     */
    public static getLanguages(): CancelablePromise<models_LanguagesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/languages',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Get organizer localization settings
     * Returns localization preferences for an organizer
     * @param organizer Organizer slug
     * @returns models_OrgLocalizationResponse OK
     * @throws ApiError
     */
    public static getOrganizersLocalization(
        organizer: string,
    ): CancelablePromise<models_OrgLocalizationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/organizers/{organizer}/localization',
            path: {
                'organizer': organizer,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * Update organizer localization settings
     * Update localization preferences for an organizer
     * @param organizer Organizer slug
     * @param body Localization settings
     * @returns models_OrgLocalizationResponse OK
     * @throws ApiError
     */
    public static putOrganizersLocalization(
        organizer: string,
        body: models_OrgLocalizationUpdateRequest,
    ): CancelablePromise<models_OrgLocalizationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/organizers/{organizer}/localization',
            path: {
                'organizer': organizer,
            },
            body: body,
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * List available regions
     * Returns all regions/countries for formatting preferences
     * @returns models_RegionsListResponse OK
     * @throws ApiError
     */
    public static getRegions(): CancelablePromise<models_RegionsListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/regions',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * List available timezones
     * Returns all timezones supported by the platform
     * @returns models_TimezonesListResponse OK
     * @throws ApiError
     */
    public static getTimezones(): CancelablePromise<models_TimezonesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/timezones',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
